import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import UnitOptimizerLogTableService from 'app/admin/unitOptimizerLog/service/UnitOptimizerLogTableService';
import ShowChartButton from '../component/ShowChartButton';

const config = {
	key: 'unitOptimizerOverviewTable',
	topic: 'unitOptimizerOverview',
	service: UnitOptimizerLogTableService,
	editFormState: item => `/unit-optimizer-overview/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh'/*, 'new'*/],
	rowAction: ['exportData'/*, 'modify', 'delete'*/],
	rowButtonList: [{ key: 'showChart', component: ShowChartButton }],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}unitOptimizerLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'table_name'
		},
		{
			key: 'description'
		}
	]
};

function UnitOptimizerOverviewTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('unitOptimizerOverviewTable', reducer('unitOptimizerOverviewTable'))(UnitOptimizerOverviewTable);
